/**
 * Fatura işlem türü rozeti — başlık, kısa ad, renk. Firma Faturalar sekmeleri
 * (depo + bayi) ve Uyarılar'daki son sipariş paneli (#367) ortak kullanır.
 *
 * `quotaShare` YÖN bilgisini taşır: aynı billType ("QuotaShare") hem giden
 * hem gelen olabilir ve bunlar ZIT işlemlerdir — rozet metni/rengi ayrılır.
 */
export const getBillTypeDetails = (type, quotaShare) => {
  switch (type) {
    case "Bill": return { title: "Fatura", short: "Fatura", color: "text-emerald-700 bg-emerald-50 border-emerald-200" };
    case "FreeUpload": return { title: "Bedelsiz Yükleme", short: "Bedelsiz", color: "text-sky-700 bg-sky-50 border-sky-200" };
    case "GetReturn": return { title: "Kota İade", short: "İade", color: "text-amber-700 bg-amber-50 border-amber-200" };
    // Kota Paylaşımı — ana firma <-> alt firma / alt bayi transferi.
    // Kota Satışı — bayi <-> müşterisi (`quotaShare.relation === "customer"`, #491).
    // Yön `quotaShare.direction` alanında ("out" giden / "in" gelen).
    case "QuotaShare": {
      const out = quotaShare?.direction === "out";
      if (quotaShare?.relation === "customer") {
        return out
          ? { title: "Kota Satışı (Giden)", short: "Giden", color: "text-rose-700 bg-rose-50 border-rose-200" }
          : { title: "Kota Satışı (Gelen)", short: "Gelen", color: "text-violet-700 bg-violet-50 border-violet-200" };
      }
      return out
        ? { title: "Kota Paylaşımı (Giden)", short: "Giden", color: "text-orange-700 bg-orange-50 border-orange-200" }
        : { title: "Kota Paylaşımı (Gelen)", short: "Gelen", color: "text-indigo-700 bg-indigo-50 border-indigo-200" };
    }
    default: return { title: "İşlem", short: "İşlem", color: "text-gray-600 bg-gray-50 border-gray-200" };
  }
};
